import { Component, Input, OnInit } from '@angular/core';
import { PlayerSessionService } from 'src/app/services/player-session.service';
import { StatesService } from 'src/app/services/states.service';

@Component({
  selector: 'app-download-component',
  templateUrl: './download-component.component.html',
  styleUrls: ['./download-component.component.scss'],
})
export class DownloadComponentComponent implements OnInit {
  @Input() component: any;

  constructor(
    private playerSessionService: PlayerSessionService,
    public statesService: StatesService
  ) {}
  ngOnInit(): void {}
  onDownloadPressed() {
    this.playerSessionService.addToLog('downloadPressed', {
      id: this.component.id,
      src: this.component.data.src,
    });
  }

  onFocus() {
    this.statesService.onFocus(this.component);
  }
  onBlur() {
    this.statesService.onBlur(this.component);
  }

  onMouseDown() {
    this.statesService.onMouseDown(this.component);
  }
  onMouseUp() {
    this.statesService.onMouseUp(this.component);
  }

  onMouseEnter() {
    this.statesService.onMouseEnter(this.component);
  }
  onMouseLeave() {
    this.statesService.onMouseLeave(this.component);
  }
}
